import { ICompleteDialogForm } from '../hooks/useCompleteDialogForm';

export class CompleteDialogValidator {
    static validateForm = (values: ICompleteDialogForm) => {
        let formErrors: any = {};

        if (!values.poNumber) {
            formErrors.poNumber = 'Field required.';
        }

        if (!values.reason) {
            formErrors.reason = 'Field required.';
        }

        return formErrors;
    }
}